import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';
import ViewsNodeServiceCards from 'src/components/ViewsNodeServiceCards/ViewsNodeServiceCards';

export const ServiceCardsSection = ({ header }) => (
  <Container fluid className="bg-shapes-job-services px-0">
    <Container className="py-6">
      <Row className="py-xl-6">
        <Col xs={12} xl={{ span: 8, offset: 2 }} className="mb-xl-6 mb-3 text-center">
          <PortableHeader content={header} />
        </Col>
        <Col xs={12} lg={{ span: 8, offset: 2 }}>
          <ViewsNodeServiceCards />
        </Col>
      </Row>
    </Container>
  </Container>
);
